import { ca } from '@cian/analytics';

export function trackMetroModalOpenEvent() {
  ca(
    'event',
    Object.assign({
      action: 'popup_metro_open',
      category: 'Listing',
      label: '',
      name: 'oldevent',
    }),
  );
}
